export default __webpack_public_path__ + "static/harvey-norman-538699472fb3e4e19b2698a7431d2a10.png";